/**
 * Created by Jerker Nord on 2024-01-11.
 */
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {Loner} from "../../Loner";
import {gsap} from "gsap";
import {LonerStatics} from "../../LonerStatics";
import {LonerSound} from "../../sound/LonerSound";

export class LonerTVPresentation implements SimplePresentation {

    private static GOD_MODE_REVEAL_DELAY: number = 0.4;
    private static GOD_MODE_AFTER_DELAY: number = 0.5;

    private _mainTL: gsap.core.Timeline;
    private _controller: SimplePresentationRunnerController;
    private _lastSoundIdxOfGMLastScatter: number = 0;

    public shouldRun(): boolean {
        return Loner.model.allScattersLanded > 0
    }

    public start(controller: SimplePresentationRunnerController): void {
        controller.setSkipCallback();

        this._controller = controller;
        this._mainTL = gsap.timeline({onComplete: () => this.complete()});
        let scattersLanded: number[] = Loner.model.scattersLanded;
        //God mode delay will only affect the last symbol
        if (Loner.model.featureTrigger == LonerStatics.MAX_WIN_TEASE_TRIGGER || Loner.model.featureTrigger == LonerStatics.MAX_WIN_TRIGGER) {
            this._mainTL.add(gsap.timeline({delay: LonerTVPresentation.GOD_MODE_REVEAL_DELAY}));
        }
        this._mainTL.add(()=>{
            if (Loner.model.wasFeatureBuy && (Loner.model.featureTrigger === LonerStatics.MAX_WIN_TRIGGER || Loner.model.featureTrigger === LonerStatics.MAX_WIN_TEASE_TRIGGER)) {
                Loner.soundPlayer.playSound(LonerSound.GM_THIRD_MONITOR_LAND);
                Loner.soundPlayer.stopGodModeResultLoop();
                if (Loner.model.gameData.featureInfo.featureTrigger === LonerStatics.MAX_WIN_TRIGGER) {
                    Loner.soundPlayer.playSound(LonerSound.GM_LETTER_X);
                } else {
                    let soundIdx:number = getSoundIndex();
                    while (this._lastSoundIdxOfGMLastScatter === soundIdx) {
                        soundIdx = getSoundIndex();
                    }
                    this._lastSoundIdxOfGMLastScatter = soundIdx;
                    Loner.soundPlayer.playSound(LonerSound.GM_NO_WIN_SOUND[soundIdx]);

                    function getSoundIndex(): number {
                        return Math.floor(Math.random() * LonerSound.GM_NO_WIN_SOUND.length);
                    }
                }
            }
        });
        for (let i: number = 0; i < scattersLanded.length; i++) {
            if (scattersLanded[i] > -1 && Loner.model.instantTVReveal[i] == false) {
                this._mainTL.add(() => {
                    Loner.scatterPool.getScatterSymbolOnReel(i).getTVTransformTL();
                });
            }
        }
        if (Loner.model.featureTrigger == LonerStatics.MAX_WIN_TEASE_TRIGGER || Loner.model.featureTrigger == LonerStatics.MAX_WIN_TRIGGER) {
            this._mainTL.add(gsap.timeline({delay: LonerTVPresentation.GOD_MODE_AFTER_DELAY}));
        }
        //Delay after all TV reveals are done
        let delay: number = 0;
        if (Loner.model.allScattersLanded == 3) {
            //It's a feature
            delay = 1.5;
        }

        this._mainTL.add(gsap.timeline({delay: delay}));
    }

    private complete(): void {
        this._controller.finish();
    }
}